import React from 'react';
import {Box, Text, Flex, Button, Stack} from '@chakra-ui/core';
import sleipnerLogo from 'assets/logo.svg';

const Header = ({resetForm}) => {
	return (
		<Box
			mb={10}
			position="sticky"
			top={0}
			left={0}
			right={0}
			zIndex={5}
			backgroundColor={'#333'}
		>
			<Box className="notch-spacer" bg="#000" />
			<Stack
				isInline
				px={{base: 5, lg: 10}}
				py={3}
				bg={'#333'}
				justifyContent="space-between"
				alignItems="center"
				minH={'70px'}
			>
				<Flex alignItems={'center'} fontSize="lg" fontWeight="bold" color="#fff">
					<img src={sleipnerLogo} alt="logo" width="60px" />
					<Text ml={4}>Sleipner Efficiency Calculator</Text>
				</Flex>
				<Button onClick={resetForm}>Reset</Button>
			</Stack>
		</Box>
	);
};

export default Header;
